import { render, staticRenderFns } from "./ContactRecordPage.vue?vue&type=template&id=770fe491&scoped=true"
import script from "./ContactRecordPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./ContactRecordPage.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ContactRecordPage.vue?vue&type=style&index=0&id=770fe491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770fe491",
  null
  
)

export default component.exports